import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { MyCreditPurchasesListStore } from "../../store/MyCreditPurchasesListStore";

type MyCreditPurchasesListDialogsProps = {
  store: MyCreditPurchasesListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de CreditPurchase.
 * Separado para mantener MyCreditPurchasesListPage más limpio.
 */
export const MyCreditPurchasesListDialogs: React.FC<MyCreditPurchasesListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
